var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',_vm._b({staticStyle:{"flex-shrink":"0"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'v-navigation-drawer',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }